export enum MembershipType {
  Person = 1,
  Company,
}
